import { View } from "./View";

export const SignUp = () => {
  return <View />;
};
